export const updateRecents = (path, max = 10) => {
  // Remove trailing slash if it exists
  if (path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  let recents = localStorage.getItem("recents");
  if (recents) {
    recents = JSON.parse(recents);
  } else {
    recents = [];
  }
  recents = [path, ...recents.filter((r) => r !== path)].slice(0, max);
  localStorage.setItem("recents", JSON.stringify(recents));
  window.dispatchEvent(new CustomEvent("updateRecentsOccurred", {}));
};

export const getRecents = () => {
  let recents = localStorage.getItem("recents");
  if (recents) {
    return JSON.parse(recents);
  }
  return [];
};

export const removeRecent = (path) => {
  let recents = localStorage.getItem("recents");
  if (recents) {
    recents = JSON.parse(recents);
    recents = recents.filter((r) => r !== path);
    localStorage.setItem("recents", JSON.stringify(recents));
    window.dispatchEvent(new Event("updateRecentsOccurred"));
  }
};
